module.exports = __webpack_public_path__ + "img/browse-vehicles-background-kia.bbba0557.png";